import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import smallLogoCarouselSectionCard from './smallLogoCarouselSectionCard.js';
var schema = defineObject('logoCarouselSection', {
    title: {
        title: 'Title',
        type: 'string'
    },
    logos: {
        title: 'Logos',
        type: 'array',
        of: [
            {
                type: 'smallLogoCarouselSectionCard'
            }
        ]
    }
}, [
    smallLogoCarouselSectionCard.schema.smallLogoCarouselSectionCard
]);
var validator = z.object({
    title: z.string(),
    logos: z.array(smallLogoCarouselSectionCard.validator)
}).partial();
schema.logoCarouselSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=logoCarouselSection.js.map